import apiClient from './api';

export interface Notification {
    id: string;
    userId: string;
    type: string;
    title: string;
    message: string;
    isRead: boolean;
    metadata?: any;
    createdAt: string;
}

export const getNotifications = async (limit = 20, unreadOnly = false) => {
    const { data } = await apiClient.get('/notifications', {
        params: { limit, unread: unreadOnly },
    });
    return data as { notifications: Notification[]; unreadCount: number };
};

export const getUnreadCount = async () => {
    const { data } = await apiClient.get('/notifications/unread-count');
    return data.count as number;
};

export const markAsRead = async (id: string) => {
    await apiClient.patch(`/notifications/${id}/read`);
};

export const markAllAsRead = async () => {
    await apiClient.patch('/notifications/read-all');
};
